import { Radio, Row } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useCallback } from "react";
import { useDefaultDeleteModal } from "../../../../../lib/hooks/defaultDeleteModal";
import { deletePaymentMethod } from "../../../../../acions/payments";

type DefaultOptionProps = {
  option: any;
  title: string;
  selectedItem: any;
  onDeleted: (id: string) => void;
};

export const DefaultOption = ({
  option,
  title,
  selectedItem,
  onDeleted,
}: DefaultOptionProps) => {
  const reloadData = useCallback(() => {
    onDeleted(option.id);
  }, [onDeleted, option.id]);

  const { openDeleteModal } = useDefaultDeleteModal(
    deletePaymentMethod,
    reloadData,
  );

  const onDeleteClick = useCallback(
    (e: any) => {
      e.preventDefault();
      openDeleteModal(
        {
          id: option.id,
          providerId: selectedItem.providerId,
          paymentMethodType: selectedItem.methodType,
        },
        `Delete ${title.toLowerCase()}`,
      );
    },
    [
      openDeleteModal,
      option.id,
      selectedItem.methodType,
      selectedItem.providerId,
      title,
    ],
  );

  return (
    <Radio
      key={option.id}
      value={option.id}
      className="method mb-2 mr-0 hoverable"
    >
      <Row className="justify-space-between align-center w-100">
        <span>{option.displayName}</span>
        <Row onClick={onDeleteClick}>
          <DeleteOutlined className="text-sm title" />
        </Row>
      </Row>
    </Radio>
  );
};
